import { render, staticRenderFns } from "./MyTaskList.vue?vue&type=template&id=b8b1101e&scoped=true&"
import script from "./MyTaskList.vue?vue&type=script&lang=js&"
export * from "./MyTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b1101e",
  null
  
)

export default component.exports